import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { _get } from "../../../api/apiClient";
import { setLoaderFalse } from "../../../Redux/loaderSlice";
import { CustomError } from "../../../api/CustomError";
import { CustomSuccess } from "../../../api/CustomSuccess";
import { HttpStatusCode } from "axios";
import store from "../../../app/store";
import { notificationRTK } from "../usernotification/notificationRTK";

const initialState = {
  healthAnalysis: null,
  currentHealthAnalysis: null,
};

export const _orgClientId = () => {
  const state = store.getState();
  return state?.orgReducer?.selectedFI?.orgClientId;
};

export const fetchHealthAnalysisSlice = createAsyncThunk(
  `fetch_health_analysis`,
  async ({ orguid, type }, thunkAPI) => {
    try {
      const config = {
        successMessage: "Fetched HealthAnalysis successfully.",
        errorMessage: "Failed to fetch HealthAnalysis!",
      };

      const _type = type == null ? `&type=none` : `&type=${type}`;

      const response = await _get(
        `/bank/healthanalysis?orguid=${orguid}${_type}`,
      );

      if (response?.statusCode !== HttpStatusCode.Ok) {
        throw CustomError(response, config);
      }

      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: true,
        });

      thunkAPI.dispatch(
        notificationRTK.util.invalidateTags(["NotificationRTK"]),
      );

      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (err) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const fetchHealthAnalysisHistory = createAsyncThunk(
  `fetch_health_analysis`,
  async ({ orguid, disableToast }, thunkAPI) => {
    try {
      const config = {
        successMessage: "Fetched HealthAnalysis successfully.",
        errorMessage: "Failed to fetch HealthAnalysis!",
        disableToast: disableToast,
      };

      let response = [];
      if (_orgClientId()) {
        response = await _get(
          `/bank/healthanalysis/history?client_id=${_orgClientId()}&type=history`,
        );

        if (response?.statusCode !== HttpStatusCode.Ok) {
          throw CustomError(response, config);
        }
      }

      const { data, error, message, status, statusCode, responseType } =
        CustomSuccess(response, {
          ...config,
          disableToast: true,
        });

      return {
        data,
        error,
        message,
        status,
        statusCode,
        responseType,
      };
    } catch (err) {
      thunkAPI.dispatch(setLoaderFalse());
      return thunkAPI.rejectWithValue(err);
    }
  },
);

export const recursiveCallAnalysisStatus = createAsyncThunk(
  `recursive_call_analysis_stauts`,
  async ({ orguid, uid }, thunkAPI) => {
    try {
      const response = await _get(
        `/bank/healthanalysis/${uid}?orguid=${orguid}&lang=en_us&source=website`,
      );
      return response.data;
    } catch (error) {
      throw error.data.error;
    }
  },
);

const healthAnalysisSlice = createSlice({
  name: "health_analysis",
  initialState,
  reducers: {
    // Add the reset action to reset the state to initial values
    resetHealthAnalysis: (state) => {
      state.healthAnalysis = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchHealthAnalysisSlice.fulfilled, (state, action) => {
        state.healthAnalysis = {
          ...state.healthAnalysis,
          payload: action.payload,
          isLoading: false,
        };
      })
      .addCase(fetchHealthAnalysisSlice.pending, (state, action) => {
        state.healthAnalysis = {
          isLoading: true,
        };
      })
      .addCase(recursiveCallAnalysisStatus.fulfilled, (state, action) => {
        state.currentHealthAnalysis = {
          ...state.currentHealthAnalysis,
          payload: action.payload,
          isLoading: false,
        };
      })
      .addCase(recursiveCallAnalysisStatus.pending, (state, action) => {
        state.currentHealthAnalysis = {
          isLoading: true,
        };
      });
  },
});

export const selectHealthAnalysis = (state) =>
  state?.healthAnalysisReducer?.healthAnalysis?.payload?.data;

export const {  resetHealthAnalysis } =
  healthAnalysisSlice.actions;

export default healthAnalysisSlice.reducer;
